<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader.ts';

  defineOptions({ name: 'ContactUsView' });

  const { t } = useI18n();

  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();
  const CustomerServiceContent = getAsyncComponentWithLoader(() => import('@/components/common/CustomerServiceContent/CustomerServiceContent.vue'));

</script>

<template>
  <PageContent class="gap-6 md:gap-10 pb-14 md:pb-14">
    <template #header>
      <h1 class="md:container">
        {{ t('contactUsPage.title') }}
      </h1>
    </template>
    <div class="md:container">
      <CustomerServiceContent />
    </div>
  </PageContent>
</template>
